<safetydirector-breadcrumb [pageName]="pageName"></safetydirector-breadcrumb>

<div class="memic-page p-t-4 memic-page--boxed">
  <div class="row">
    <div class="col-md-12">
      <div class="memic-panel panel">
        <div class="panel-body">
          <section *ngIf="!resources">
            <em>Loading Resources...</em>
          </section>
          <section *ngIf="resources">
            <div class="row">
              <div class="col-md-12">
                <span class="badge badge-primary">You have {{getFavoritesCount()}} favorite documents</span>
              </div>
            </div>

            <!-- Search Box -->
            <div class="memic-input-group memic-input-group--borderless input-group memic-search--page m-t-2 m-b-2">
              <input [(ngModel)]="searchString" (keyup.enter)="filterResources()" name="searchString" type="text" placeholder="Search">
              <button type="button" (click)="filterResources(true)" class="btn bg-transparent" style="margin-left: -40px; z-index: 100;">
                <i class="fa fa-times"></i>
              </button>
              <span (click)="filterResources()" class="input-group-addon"><i class="fa fa-search" aria-hidden="true"></i></span>
            </div>
            <!--// Search Box -->

            <div class="row">
              <div class="col-md-12">
                <span class="badge badge-primary">{{resources.length}} Resources</span>
              </div>
            </div>

            <ul class="memic-list memic-list--details memic-list--brdless list-group m-a-0" *ngFor="let r of resources">
              <li class="memic-list__body list-group-item p-x-0">
                <div class="memic-list__body-left">
                  <img #fileIcon class="memic-icn memic-icn-png" [src]="'../assets/icons/' + r.blobExtension.replace('.', '') +'.png'">
                </div>
                <div class="memic-list__body-right">
                  <header class="memic-list__header">
                    <h2 class="memic-list__title">
                      <a href="javascript:void(null)" (click)="downloadFile(r, fileIcon)" *ngIf="r.documentType != 'Video'">{{r.title}}</a>

                      <a href="javascript:void(null)" *ngIf="r.documentType == 'Video'" (click)="openModal(videoModal, r)">{{r.title}}</a>

                      <a href="javascript:void(null)" class="m-l-2" (click)="toggleFavorite(r)">
                        <i class="fa-star" [ngClass]="{'fa-regular': !r.favorite, 'fa' : r.favorite }" aria-hidden="true"> </i>
                      </a>
                    </h2>

                  </header>
                  <div class="memic-list__content">{{r.resourceDescription}}</div>

                  <!-- Tags -->
                  <div class="memic-list__body" [innerHTML]="getKeyWordsHtml(r, true)">
                  </div>
                  <div class="memic-list__body" [innerHTML]="getKeyWordsHtml(r, false)" *ngIf="r.more">
                  </div>
                  <!-- // Tags -->
                  <!-- Tags Accordion -->
                  <a *ngIf="getKeyWords(r).length > tagsLength" class="memic-tag m-r-1 m-t-1" href="javascript:void(null)" (click)="toggleTags(r)">
                    <i class="fa p-l-1 m-r-1" [ngClass]="{'fa-plus': !r.more, 'fa-minus' : r.more }" aria-hidden="true"> </i>
                    <span *ngIf="!r.more" class="p-r-1">more</span>
                    <span *ngIf="r.more" class="p-r-1">less</span>
                  </a>
                  <!-- // Tags Accordion -->
                  <!-- Related Documents-->
                  <a *ngIf="r.relatedDocument.length > 0" class="memic-tag m-t-1" data-bs-toggle="collapse" href="#related-docs-{{r.id}}" [attr.data-bs-target]="'#related-docs-' +r.id" role="button" aria-expanded="false" aria-controls="collapseRelatedDocumets">
                    <i class="fa fa-paperclip m-r-2" aria-hidden="true"></i>{{r.relatedDocument.length}} Related Documents
                  </a>
                  <div class="memic-list__content accordion-collapse collapse" [attr.aria-labelledby]="'related-docs-' + r.id" id="related-docs-{{r.id}}" *ngFor="let relatedDoc of r.relatedDocument">
                    <div class="memic-list__body-left">
                      <img #fileIcon class="memic-icn memic-icn-png" [src]="'../assets/icons/' + relatedDoc.blobExtension.replace('.', '') +'.png'">
                    </div>
                    <div class="memic-list__body-right">

                      <header class="memic-list__header m-b-2">
                        <h2 class="memic-list__title">
                          <a href="javascript:void(null)" (click)="downloadFile(relatedDoc, fileIcon)" *ngIf="relatedDoc.documentType != 'Video'">{{relatedDoc.title}}</a>

                          <a href="javascript:void(null)" *ngIf="relatedDoc.documentType == 'Video'" (click)="openModal(videoModal, relatedDoc)">{{relatedDoc.title}}</a>
                        </h2>
                      </header>
                    </div>
                  </div>
                  <!-- // Related Documents-->
                </div>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #videoModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="editProfileLabel">{{selectedVideo.title}}</h4>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-8">
        <iframe [src]="selectedVideoUrl" width="750" height="425" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
      <div class="col-md-4">
        <p class="memic-webinars--description">{{selectedVideo.resourceDescription}}</p>
      </div>
    </div>
  </div>
</ng-template>
